interface DownloadFile {
  blob?: Blob
  url?: string
  filename?: string
  viewFirst?: boolean
}

export function downloadFile({ blob, url, filename, viewFirst }: DownloadFile) {
  if (!blob && !url) throw new Error('No Blob or URL')

  const fileUrl = blob ? URL.createObjectURL(blob) : url!

  if (viewFirst) {
    window.open(fileUrl, '_blank')
  } else {
    const a = document.createElement('a')
    a.href = fileUrl
    if (filename) a.download = filename

    // Se for uma URL ele não faz o download, então aqui ele abre em outra aba
    if (!blob) a.target = '_blank'

    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}
